var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { marketColumnsDisplay } from "../../../../../constants";
import { ContainerQuery } from "react-container-query";
import { SecondaryHeading, HeadingTitle } from "../../../components";
import { RenderMarketNames } from "../RenderMarketNames";
var RenderCustomHeading = /** @class */ (function (_super) {
    __extends(RenderCustomHeading, _super);
    function RenderCustomHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RenderCustomHeading.prototype.renderCustomHeading = function (params) {
        return React.createElement(SecondaryHeading, { key: "subheading-" + this.props.id, cardType: this.props.cardType },
            React.createElement(HeadingTitle, { name: "", eventsCount: "" }),
            React.createElement(RenderMarketNames, { marketNames: this.props.marketNames, marketTemplates: this.props.marketTemplates, queryParams: params }));
    };
    RenderCustomHeading.prototype.render = function () {
        var _this = this;
        return (React.createElement(ContainerQuery, { query: marketColumnsDisplay }, function (params) { return _this.renderCustomHeading(params); }));
    };
    return RenderCustomHeading;
}(React.PureComponent));
export { RenderCustomHeading };
//# sourceMappingURL=RenderCustomHeading.js.map